module.exports = __webpack_public_path__ + "static/media/on-eye_classic-Mystic.9e180882.jpg";